import { StyledInput } from '@risk-first/ui-core';
import { memo, forwardRef, createElement } from 'react';
import ReactInputMask from 'react-input-mask';
const MaskedInput = memo(forwardRef((props, ref) => {
  return createElement(ReactInputMask, Object.assign({}, props), inputProps => createElement(StyledInput, Object.assign({
    ref: ref
  }, inputProps)));
}));
export { MaskedInput };
//# sourceMappingURL=index.js.map
